import React, { useState, useEffect } from 'react';
import './InventoryWidget.css';

function InventoryWidget({ onViewAll }) {
  const [currentSnapshot, setCurrentSnapshot] = useState(null);
  const [growth, setGrowth] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await fetch('/backend/api/inventory/get-stats.php', {
        credentials: 'include'
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setCurrentSnapshot(data.current);
          setGrowth(data.growth_indicators);
        }
      }
    } catch (error) {
      console.error('Error fetching inventory stats:', error);
    } finally {
      setLoading(false);
    }
  };

  const formatGrowth = (value) => {
    if (!value) return null;
    const sign = value > 0 ? '+' : '';
    return `${sign}${value}%`;
  };

  const getGrowthColor = (value) => {
    if (!value) return '#999';
    if (value > 0) return '#10b981';
    if (value < 0) return '#ef4444';
    return '#999';
  };

  const formatNumber = (num) => {
    if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
    if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
    return num.toString();
  };

  if (loading) {
    return (
      <div className="inventory-widget">
        <div className="widget-header">
          <h3>Inventory & Stats</h3>
        </div>
        <div className="widget-loading">Loading...</div>
      </div>
    );
  }

  if (!currentSnapshot) {
    return (
      <div className="inventory-widget">
        <div className="widget-header">
          <h3>Inventory & Stats</h3>
          <button className="btn-view-all" onClick={onViewAll}>View All</button>
        </div>
        <div className="widget-empty">
          <p>No inventory data yet</p>
          <p className="empty-subtitle">Take your first inventory to track your business growth</p>
        </div>
      </div>
    );
  }

  return (
    <div className="inventory-widget">
      <div className="widget-header">
        <h3>Inventory & Stats</h3>
        <button className="btn-view-all" onClick={onViewAll}>View All</button>
      </div>
      
      <div className="inventory-metrics-compact">
        <div className="metric-box">
          <div className="metric-value">{formatNumber(currentSnapshot.infinity_total)}</div>
          <div className="metric-label">INFINITY</div>
          {growth?.infinity_total && (
            <div className="metric-growth" style={{ color: getGrowthColor(growth.infinity_total) }}>
              {formatGrowth(growth.infinity_total)}
            </div>
          )}
        </div>
        
        <div className="metric-box">
          <div className="metric-value">{formatNumber(currentSnapshot.monthly_total)}</div>
          <div className="metric-label">MONTHLY</div>
          {growth?.monthly_total && (
            <div className="metric-growth" style={{ color: getGrowthColor(growth.monthly_total) }}>
              {formatGrowth(growth.monthly_total)}
            </div>
          )}
        </div>
        
        <div className="metric-box">
          <div className="metric-value">{currentSnapshot.community_size.toLocaleString()}</div>
          <div className="metric-label">COMMUNITY</div>
          {growth?.community_size && (
            <div className="metric-growth" style={{ color: getGrowthColor(growth.community_size) }}>
              {formatGrowth(growth.community_size)}
            </div>
          )}
        </div>
      </div>
      
      <div className="widget-footer">
        <span className="last-updated">
          Last updated: {new Date(currentSnapshot.snapshot_date).toLocaleDateString()}
        </span>
      </div>
    </div>
  );
}

export default InventoryWidget;
